const UserEdit = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none">
      <path
        d="M8.99783 9.00054C10.9922 9.00054 12.6089 7.38379 12.6089 5.38943C12.6089 3.39507 10.9922 1.77832 8.99783 1.77832C7.00347 1.77832 5.38672 3.39507 5.38672 5.38943C5.38672 7.38379 7.00347 9.00054 8.99783 9.00054Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2062 11.7005L11.6495 14.2572C11.5484 14.3583 11.4545 14.546 11.4329 14.6833L11.2957 15.6582C11.2451 16.0121 11.4907 16.2577 11.8446 16.2071L12.8195 16.0699C12.9568 16.0482 13.1518 15.9544 13.2457 15.8533L15.8023 13.2966C16.2429 12.856 16.4523 12.3432 15.8023 11.6932C15.1595 11.0505 14.6468 11.2599 14.2062 11.7005Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8359 12.0693C14.0526 12.8493 14.6592 13.456 15.4392 13.6726"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.79297 16.2225C2.79297 13.4275 5.57354 11.167 8.99688 11.167C9.74799 11.167 10.4702 11.2753 11.1419 11.4775"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default UserEdit;
